<script context="module">
  import {writable} from 'svelte/store';

  const currentID$ = writable(null);

  let counter = 0;
</script>

<script>
  import {onMount} from 'svelte';
  import {createEventDispatcher} from 'svelte';
  import {Icon} from '@/widgets/icon';

  let className = '';
  export {className as class};
  export let style = '';
  export let value = undefined;
  export let disabled = false;
  export let options = null;
  export let white = false;
  export let before = false;
  export let placeholder = '';
  export let label = '';
  export let type = 'underline';
  export let itemStyle = 'height: 38px;line-height: 38px;';

  const dispatch = createEventDispatcher();

  const id = counter++;

  let showDropdown = false;
  let displayText = label;

  $: updateDisplayText(options, value);

  onMount(() => {
    document.addEventListener('click', hideDropdown);
    return () => document.removeEventListener('click', hideDropdown);
  });

  onMount(() =>
    currentID$.subscribe((currentID) => {
      if (currentID === id) {
        return;
      }

      hideDropdown();
    })
  );

  function hideDropdown() {
    showDropdown = false;
  }

  function updateDisplayText(options, value) {
    if (options.length < 1 || value === undefined) {
      displayText = placeholder;
      return;
    }

    const item = options.find((o) => o.value === value);
    if (item) {
      displayText = label ? `${label}：${item.text}` : item.text;
      return;
    }

    displayText = placeholder;
  }

  function handleClickDown(e) {
    e.stopPropagation();
    if (disabled) {
      return;
    }
    showDropdown = !showDropdown;
    if (showDropdown) {
      currentID$.set(id);
    }
    dispatch('click');
  }

  function handleClickFun(option) {
    return function (e) {
      if (option.disabled) {
        e.stopPropagation();
        return;
      }
      value = option.value;
      showDropdown = !showDropdown;
      if (showDropdown) {
        currentID$.set(id);
      }
      dispatch('change', {value, option});
    };
  }
</script>

<style>
  .wrap {
    height: 40px;
    line-height: 40px;
  }
  .underline {
    border-bottom: 1px solid #e5e5e5;
  }
  .border {
    border: 1px solid #e5e5e5;
    border-radius: 8px;
    padding: 0 10px;
  }
  .no-border {
    border: none;
  }
  .white.wrap:hover,
  .white.wrap:focus {
    border-bottom-color: var(--blue-main-hover);
  }
  .white span,
  .white .arrow {
    color: #fff;
  }
  .white.before span::before {
    position: absolute;
    top: 4px;
    left: -10px;
    font-size: 18px;
    color: #fff;
    content: '*';
    vertical-align: middle;
  }
  .underline:hover {
    border-color: var(--blue-main);
  }
  .wrap.disabled {
    pointer-events: none;
    opacity: 0.4;
  }
  .arrow {
    transition: transform 0.2s;
  }
  ul {
    position: absolute;
    top: 100%;
    left: 0;
    display: none;
    border-radius: 8px;
    width: 100%;
    max-height: 200px;
    background: #fff;
    overflow-x: hidden;
    overflow-y: auto;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  }
  ul li {
    margin: 0;
    padding-left: 10px;
  }
  ul li:hover {
    background: #f8f8f8;
  }
  ul li:active {
    color: var(--blue-main-active);
  }
  .dropdown {
    z-index: 99999;
    display: inline-block;
  }
  .animation {
    transform: rotate(180deg);
    -moz-transform: rotate(180deg); /* Firefox */
    -webkit-transform: rotate(180deg); /* Safari 和 Chrome */
  }
  .active {
    color: var(--blue);
  }
  .option.disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
</style>

<div
  class="wrap pr T2 {className}"
  class:underline={type === 'underline'}
  class:border={type === 'border'}
  class:no-border={type === 'no-border'}
  class:disabled
  class:white
  class:before
  {style}
  on:click
>
  <div class="df aic jcsb" on:click={handleClickDown}>
    <slot name="displayItem" {displayText}>
      <span class="f1 cp wp100 cb ml4 wsn ooo">{displayText}</span>
    </slot>
    {#if $$slots.selectArrow}
      <slot name="selectArrow" className={showDropdown && 'animation'} />
    {:else}
      <div class="arrow">
        <Icon name={showDropdown ? 'selectUpFilled' : 'selectDownFilled'} color="var(--T1)" width={16} height={16} />
      </div>
    {/if}
  </div>
  <ul class="pa sv" class:dropdown={showDropdown}>
    {#each options as option}
      <li class="option T2 cp" class:disabled={option.disabled} style={itemStyle} on:click={handleClickFun(option)}>
        <slot name="item" {option}>
          <div class="f1 cp wp100 cb ml4 wsn ooo" class:active={displayText === option.text}>{option.text}</div>
        </slot>
      </li>
    {/each}
    <slot name="action" />
  </ul>
</div>
